import type {
  ApiSourceLabelsRequest,
  ApiSourceLabelsResponse,
} from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import type { ISourceLabelService } from './ISourceLabelService';

class SourceLabelService implements ISourceLabelService {
  postLabels(request: ApiSourceLabelsRequest): Promise<ApiSourceLabelsResponse> {
    return api_config
      .post<ApiSourceLabelsResponse>('/sources/labels', request)
      .then((response) => response.data);
  }
}

export default new SourceLabelService();
